import React from 'react';
import { OptionsMonetaryText } from './OptionsMonetaryText';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { Info } from 'lucide-react';
import { formatSignedNative, formatThetaPerDay, formatVegaPerIvPoint } from './optionsPortfolioRiskUtils';
import { useOptionsLocale } from '../../context/OptionsLanguageContext';

const GreekMetric = ({ label, value, tooltip = null, testId }) => (
  <div className="rounded-2xl border border-white/10 bg-white/[0.03] px-3 py-3" data-testid={testId}>
    <div className="flex items-center gap-1.5">
      <p className="text-[11px] uppercase tracking-[0.18em] text-white/40">{label}</p>
      {tooltip ? (
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              type="button"
              className="shrink-0 text-white/28 transition-colors hover:text-white/55"
              data-testid={`${testId}-tooltip-trigger`}
              aria-label={label}
            >
              <Info size={12} />
            </button>
          </TooltipTrigger>
          <TooltipContent className="max-w-[240px] border border-white/10 bg-[#11161E] text-white/90" data-testid={`${testId}-tooltip-content`}>
            {tooltip}
          </TooltipContent>
        </Tooltip>
      ) : null}
    </div>
    <p className="mt-1 text-sm font-semibold text-white tabular-nums" data-testid={`${testId}-value`}><OptionsMonetaryText value={value} iconSize={14} /></p>
  </div>
);

export const OptionsLegGreeksGrid = ({ leg, testIdPrefix }) => {
  const { t } = useOptionsLocale();

  return (
    <TooltipProvider>
      <div className="grid gap-3 sm:grid-cols-3" data-testid={`${testIdPrefix}-grid`}>
        <GreekMetric label={t('positions.delta')} value={formatSignedNative(leg.current_delta, leg.underlying, 4)} testId={`${testIdPrefix}-delta`} />
        <GreekMetric label={t('positions.theta')} tooltip={t('positions.thetaTooltip')} value={formatThetaPerDay(leg.current_theta)} testId={`${testIdPrefix}-theta`} />
        <GreekMetric label={t('positions.vega')} tooltip={t('positions.vegaTooltip')} value={formatVegaPerIvPoint(leg.current_vega)} testId={`${testIdPrefix}-vega`} />
      </div>
    </TooltipProvider>
  );
};

export default OptionsLegGreeksGrid;